import React from 'react';
import { AppLogoStyled, Title } from './index.styled';

const AppLogo = () => {
    return (
        <AppLogoStyled>
          <Title ><span>NEX CASH</span><br/><span>ADMIN DASHBOARD</span></Title>
        </AppLogoStyled>
    );
};

export default AppLogo;
